const addAccordionListeners = () => {
    document.addEventListener("click", function(e) {
        const accordionToggle = e.target.closest(".js-accordionToggle");
        if (!accordionToggle) return;

        e.preventDefault();

        const panel = accordionToggle.parentElement.querySelector(".c-accordion__panel");
        if (!panel) return;

        accordionToggle.classList.toggle("is-active");
        panel.classList.toggle("is-active");
    });

    document.addEventListener("keydown", function(e) {
        const accordionToggle = e.target.closest(".js-accordionToggle");
        if (!accordionToggle) return;

        if (e.key === "Enter") {
            e.preventDefault();

            const panel = accordionToggle.parentElement.querySelector(".c-accordion__panel");
            if (!panel) return;

            accordionToggle.classList.toggle("is-active");
            panel.classList.toggle("is-active");
        }
    });

};

addAccordionListeners();
